"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _Channel = _interopRequireDefault(require("./Channel"));
var _ = require("../..");
var _utils = require("../../../utils");
require("../GroupChats.less");
var _lodash = require("lodash");
var _utils2 = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SingleGroupChat = function SingleGroupChat(_ref) {
  var chatClient = _ref.chatClient,
    groupId = _ref.groupId,
    globalBan = _ref.globalBan,
    _ref$setChannel = _ref.setChannel,
    setChannelProp = _ref$setChannel === void 0 ? _lodash.noop : _ref$setChannel;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    channel = _useState2[0],
    setChannel = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!chatClient) {
      return;
    }
    var initChannels = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var channels;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _utils.chatQueryService.queryChannels({
                  client: chatClient,
                  filter: {
                    type: _utils.SUPPORT_GROUP_CHANNEL_TYPES.GROUP_BOUND,
                    id: {
                      $in: [groupId]
                    }
                  }
                });
              case 2:
                channels = _context.sent;
                setChannel(channels[0]);
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function initChannels() {
        return _ref2.apply(this, arguments);
      };
    }();
    initChannels();
  }, [chatClient]);
  (0, _react.useEffect)(function () {
    setChannelProp(channel);
  }, [channel]);
  if (!chatClient || !channel) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "GroupChats"
  }, /*#__PURE__*/_react.default.createElement(_utils2.CustomChatContextProvider, null, /*#__PURE__*/_react.default.createElement(_streamChatReact.Chat, {
    client: chatClient,
    theme: "team light"
  }, /*#__PURE__*/_react.default.createElement(_Channel.default, {
    channel: channel,
    client: chatClient,
    globalBan: globalBan
  }))));
};
var _default = SingleGroupChat;
exports.default = _default;